import { useState } from "react";
import { updateUserPassword } from "../../../apis";
import Button from "../Button";
import DialogWrapper from "../Dialog";
import { Input } from "../Input";

const ChangePasswordModal = ({ open, close }) => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [disableSaveButton, setDisableSaveButton] = useState(false);

  const [inputError, setInputError] = useState({
    currentPassword: "",
    newPassword: "",
  });

  const onSave = async () => {
    if (newPassword.length < 6) {
      setInputError((prev) => ({
        ...prev,
        newPassword: "Password should contain min 6 characters.",
        currentPassword: "",
      }));
      return;
    }
    if (currentPassword.length < 6) {
      setInputError((prev) => ({
        ...prev,
        currentPassword: "Please input proper current password.",
        newPassword: "",
      }));
      return;
    }
    try {
      setDisableSaveButton(true);
      const { data } = await updateUserPassword(newPassword, currentPassword);
      window.Toast.fire({
        title: "Password changed successfully",
        icon: "success",
      });
      close();
    } catch (error) {
      console.log(error);
      console.log(error.response);
      if (error?.response?.status === 412) {
        setInputError((prev) => ({
          ...prev,
          currentPassword: error.response.data.message,
          newPassword: "",
        }));
      } else {
        window.Toast.fire({
          icon: "error",
          title: "Something went wrong",
        });
      }
    } finally {
      setDisableSaveButton(false);
    }
  };

  return (
    <DialogWrapper
      open={open ?? false}
      close={close}
      title="Change password"
      widthCustom="w-[500px]"
    >
      <div className="flex flex-col gap-8 max-w-[300px]">
        <Input
          error={inputError.currentPassword}
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e)}
          required
          placeholder="Enter your current password"
          onKeyDown={() => {}}
        />
        <Input
          error={inputError.newPassword}
          value={newPassword}
          onChange={(e) => setNewPassword(e)}
          required
          placeholder="Enter your new password"
          onKeyDown={onSave}
        />
      </div>
      <div className="w-full flex items-center">
        <Button
          text="Save"
          className="mx-auto my-4"
          disabled={disableSaveButton}
          onClick={onSave}
        ></Button>
      </div>
    </DialogWrapper>
  );
};

export default ChangePasswordModal;
